import { getRouteUrl } from '@nackle/service-urls';

export const AUTHORITY = getRouteUrl( 'ID_PROVIDER' );
export const EXPERIENCE_REGISTRY_API_URL = `${ getRouteUrl( 'EXPERIENCE_REGISTRY_API' ) }/services/v1`;
